/** Minimal listener list; emit() iterates without allocating. */
export class Listeners<T> {
  private list: ((v: T) => void)[] = [];

  add(cb: (v: T) => void): () => void {
    this.list = [...this.list, cb];
    return () => {
      this.list = this.list.filter((f) => f !== cb);
    };
  }

  emit(v: T): void {
    const l = this.list;
    for (let i = 0; i < l.length; i++) {
      try {
        l[i](v);
      } catch (err) {
        console.error(err);
      }
    }
  }

  get size(): number {
    return this.list.length;
  }

  clear(): void {
    this.list = [];
  }
}
